export const ActiveAdminContext = require.context(
  ".",
  true,
  /\_controller.js$/
);
